import { render, staticRenderFns } from "./transferFrom.vue?vue&type=template&id=5b12d40e&"
import script from "./transferFrom.vue?vue&type=script&lang=js&"
export * from "./transferFrom.vue?vue&type=script&lang=js&"
import style0 from "./transferFrom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports